// Full-screen functionality for Phaser game
(function() {
    'use strict';
    
    let fullscreenButton;
    
    // Wait for DOM to be ready
    function init() {
        createFullscreenButton();
        setupEventListeners();
    }
    
    function createFullscreenButton() {
        // Create the fullscreen button
        fullscreenButton = document.createElement('button');
        fullscreenButton.id = 'fullscreen-button';
        
        // Add SVG icons for enter and exit fullscreen
        fullscreenButton.innerHTML = `
    <svg viewBox="0 0 24 24">
        <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="white"/>
    </svg>
    <svg viewBox="0 0 24 24">
        <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" fill="white"/>
    </svg>
    `;
        
        document.body.appendChild(fullscreenButton);
    }
    
    function setupEventListeners() {
        // Button click handler
        fullscreenButton.addEventListener('click', toggleFullscreen);
        
        // Listen for fullscreen change events
        document.addEventListener('fullscreenchange', onFullscreenChange);
    }
    
    function toggleFullscreen() {
        if (!document.fullscreenElement) {
            document.body.requestFullscreen();
            document.body.setAttribute("fullscreen", "");
            if (window.game && window.game.scale) {
                window.game.scale.fullScreenScaleMode = Phaser.Scale.FIT;
                window.game.scale.startFullscreen();
            }
        } else {
            document.exitFullscreen();
            document.body.removeAttribute("fullscreen");
        }
    }

    function onFullscreenChange() {
        const inFullscreen = !!document.fullscreenElement;
        updateBodyAttribute(inFullscreen);
    }
    
    function updateBodyAttribute(inFullscreen) {
        if (inFullscreen) {
            document.body.setAttribute('fullscreen', '');
        } else {
            document.body.removeAttribute('fullscreen');
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();